module.exports = __webpack_public_path__ + "img/br.85e5c527.svg";